
<template>
  <naj-box :title="locales.sectionTitle">
     <v-row>
      <v-col cols="3">
        <naj-input
          :type-id="formFieldType.number"
          :label="locales.caseCode"
          :value.sync="formModel.caseCode"
          :validates="`required|long|max:10`"
        ></naj-input>
      </v-col>
    </v-row>
  </naj-box>
</template>
<script>
export default {
  inject: ['$validator'],
  name: 'CaseJudgementDocument',
  props: {
    formModel: {
      type: Object,
      required: true,
    },
    viewMode: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    locales() {
      return this.local.dynamicFormAdmin.customComponents.judgementDocument;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
